/**
 * The red asterisk that marks a mandatory field.
 *
 * WHY A COMPONENT RATHER THAN A CHARACTER
 * Required labels were built by appending the literal string `" *"` to the
 * label text. A bare text node cannot be styled, so every asterisk in the app
 * rendered in the same muted grey as the label itself and read as punctuation
 * rather than as "this field is mandatory". Wrapping it is the only way to give
 * it colour, and doing it in one place keeps every form consistent.
 *
 * ACCESSIBILITY
 * `aria-hidden` is deliberate. The input already carries `required`, which is
 * what a screen reader announces; letting it also read the asterisk produces
 * "Subject name star, required" — noise that helps nobody. The colour is a
 * visual affordance for sighted users only, and colour is never the sole
 * signal because the underlying `required` attribute still drives validation.
 */
export const RequiredMark = () => (
    <span className="required-mark" aria-hidden="true" title="Required">
        *
    </span>
);
